import React from 'react'

const Discount = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={80}
        height={80}
        viewBox="0 0 80 80"
        fill="none"
        {...props}
    >
        <circle cx={40} cy={40} r={40} fill="#fff" />
        <g clipPath="url(#o)">
            <path
                fill="#EF8078"
                d="M33.177 43.726c-.629-1.371-1.205-2.804-1.45-4.219a9.552 9.552 0 0 1 .026-3.275c.56-3.127 2.577-5.223 5.171-5.232 2-.009 4.236 1.144 6.228 2.9 1.974 1.738 3.8 4.166 4.804 6.909 2.192 6.035-.97 9.232-4.35 10.29-1.537.48-3.983.663-5.817-.77-1.834-1.432-3.503-4.21-4.603-6.594l-.009-.009Z"
            />
            <path
                stroke="#686058"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.091}
                d="M32.087 29.24c.011.698.186 1.33.535 1.636"
            />
            <path
                stroke="#686058"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.091}
                d="m29.873 30.582-2.826 8.465 10.037 19.408 18.436-9.36-9.85-19.986s-7.146-2.64-10.888-3.25c0 0-1.375-.306-2.073.774-.415.633-.655 1.69-.633 2.607"
            />
            <path
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.091}
                d="M38.775 49.75s1.876-3.448 1.963-8.063c.066-3.49 1.113-5.64 1.778-6.807M36.45 41.25a1.876 1.876 0 1 0 0-3.752 1.876 1.876 0 0 0 0 3.753ZM45.036 46.018a1.876 1.876 0 1 0 0-3.752 1.876 1.876 0 0 0 0 3.752Z"
            />
            <path
                stroke="#686058"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.091}
                d="M32.425 30.636c.142.23.35.426.6.557.797.436 1.8.141 2.237-.666.436-.807.142-1.8-.666-2.236"
            />
            <path
                stroke="#686058"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.091}
                d="M33.844 29.404s-1.222-7.211-6.731-8.662c-5.498-1.451-4.626 5.596 2.509 6.654"
            />
        </g>
    </svg>
)
export default Discount
